import { render, staticRenderFns } from "./BigLegends.vue?vue&type=template&id=e5ee5b70&scoped=true&"
import script from "./BigLegends.vue?vue&type=script&lang=js&"
export * from "./BigLegends.vue?vue&type=script&lang=js&"
import style0 from "./BigLegends.vue?vue&type=style&index=0&id=e5ee5b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ee5b70",
  null
  
)

export default component.exports